import { ContasReceber } from './../../model/financeiro/contasReceber';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GenericService } from '../generics/generic.service';

@Injectable({
  providedIn: 'root'
})
export class ContasReceberService extends GenericService<ContasReceber>{
  constructor(http: HttpClient) {
    super(http);
    super.initResource("contasreceber")
  }

  finalizarOs(idEmpresa: number, oseId: number, parcelas: ContasReceber[]): Observable<any> {
    const url = `${this.url}/${idEmpresa}/finalizaros/${oseId}`;
    return this.http.post<any>(url, parcelas);
  }

  /**
   * Retorna a soma dos valores em aberto/pendente no contas a receber do cliente.
   * Usado para calcular: Limite Disp. = PES_LIMITE_CRED_VENDA - totalEmAberto
   */
  getTotalEmAberto(idEmpresa: number, pessoaId: number): Observable<number> {
    const url = `${this.url}/${idEmpresa}/totalemaberto/${pessoaId}`;
    return this.http.get<number>(url);
  }

  /**
   * Estorna o financeiro de uma OS: exclui parcelas ABERTA/PENDENTE do contas a receber.
   * Rejeita se houver parcelas já PAGAS.
   */
  estornarOs(idEmpresa: number, oseId: number): Observable<string> {
    const url = `${this.url}/${idEmpresa}/estornaros/${oseId}`;
    return this.http.delete<string>(url, { responseType: 'text' as 'json' });
  }
}
